module.exports = __webpack_public_path__ + "49f1965775b0e444fa20b87e49289987.MP3";